import { render, staticRenderFns } from "./department_list.vue?vue&type=template&id=520fb6a0&scoped=true"
import script from "./department_list.vue?vue&type=script&lang=js"
export * from "./department_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520fb6a0",
  null
  
)

export default component.exports